import { Membership } from '@mews-commander/guest-profile';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Divider, Stack, Tag, Typography } from '@optimus-web/core';
import { ItemLabel } from '../../common';

interface LoyaltyItemProps {
    membership: Membership;
    showDivider?: boolean;
}

export const LoyaltyItem = ({ membership, showDivider }: LoyaltyItemProps) => {
    const { code, expirationDate, program, tier, points, isPrimary } = membership;
    return (
        <Stack spacing="100" vertical>
            <Stack distribution="space-between">
                {program?.name ? (
                    <Typography textStyle="bodyMediumStrong" variant="primary" as="div">
                        {program.name}
                    </Typography>
                ) : null}
                {isPrimary ? <Tag variant="basicBold">{lt('IsPrimary')}</Tag> : null}
            </Stack>
            {code ? <ItemLabel label={lt('AccountMergeGuestDetailLoyaltyMembership')} value={code} /> : null}
            {tier?.name ? <ItemLabel label={lt('Tier')} value={tier.name} /> : null}
            {expirationDate ? (
                <ItemLabel
                    label={lt('AccountMergeGuestDetailLoyaltyExpirationDate')}
                    value={<LocalizedDateFromUtc utcString={expirationDate} />}
                />
            ) : null}
            {points ? <ItemLabel label={lt('Points')} value={points.toString()} /> : null}
            {showDivider ? <Divider /> : null}
        </Stack>
    );
};
